import React, {useState, useEffect} from 'react';
import axios from '../../axios-instance';
import Logo from '../UI/Logo/Logo';
import { useSelector } from 'react-redux';
import Button from '../UI/Button/Button';
import CountDown from '../UI/CountDown/CountDown';
import Video from '../UI/Video/Video';
import {updateContentStatus} from '../../utils/helpers';
import correctHeaderImage from '../../images/choice-page-headers/correct-header.png';
import incorrectHeaderImage from '../../images/choice-page-headers/wrong-header.png';
import { withCookies, useCookies } from 'react-cookie';

const Question = (props) => {
    const [
        cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8FPVID', 'A8CFVLH', 'A8USRID', 'A8USRTKN']); 

    const [choices, setChoices] = useState();
    const [showLogo, setShowLogo] = useState(false);
    const [showHeader, setShowHeader] = useState(false);
    const [headerMessage, setHeaderMessage] = useState(null);
    const [headerImage, setHeaderImage] = useState(null);
    const [showCountdown, setShowContdown] = useState(true);
    const [countDownDuration, setCountDownDuration] = useState(process.env.REACT_APP_CONTENT_QUESTION_COUNTDOWN_DURATION ? parseInt(process.env.REACT_APP_CONTENT_QUESTION_COUNTDOWN_DURATION) : null);
    const [isCountDownPlaying, setIsCountDownPlaying] = useState(false);
    
    const device = useSelector((state) => state.device);
    const user = (cookies.A8USRID && cookies.A8USRTKN) && {id:cookies.A8USRID, token:cookies.A8USRTKN}    
    const [timeUp, setTimeUp] = useState(false);
    const [selectedAnswer, setSelectedAnswer] = useState(null); 
    const [hero, setHero] = useState(null); 
    const [video, setVideo] = useState({
        path : null,
        format : null,
        pauseAt : 0,
        resumeAt : 0        
    });
    const [videoIsPlaying, setVideoIsPlaying] = useState(false);

    const setInitialButtonState = (data) => {
        const expandedData = [];
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            element.iconType = process.env.REACT_APP_BUTTON_DEFAULT_ICON;
            element.backgroundColor = process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR;
            expandedData.push(element);                    
        }
        setChoices(expandedData);        
    }

    useEffect(() => {
        // Track view impression on load
        console.log(user);
        updateContentStatus(props.question, 1, device.deviceDetails, user);
    }, [])

    useEffect(() => {                
        if(props.question.choices) {
            setInitialButtonState(props.question.choices);
        } else {

            const endpoint = user ? `/user/${user.id}/question/${props.question.id}/choices` : `/device/${device.deviceDetails.uuid}/question/${props.question.id}/choices`;
            
            let headers = {}
            headers['x-device-uuid'] = `${device.deviceDetails.uuid}`;

            if(user) {
                headers['Authorization'] = 'Bearer ' + user.token; 
            }
            
            axios.get(
                endpoint, {headers: headers}
            ).then((res)=>{
                 if (res && res.data) {
                    setInitialButtonState(res.data);
                } else {
    
                }
            }).catch((err)=>{
    
            }).finally();
        }        
    }, [props.question.choices]) 

    useEffect(() => {
    
        if(props.question.linked_assets) {
            props.question.linked_assets.forEach(asset => {
                if(asset.component === 'images' && asset.sub_component === 'hero' && asset.type === 'image') {
                    setHero({src : asset.path, alt: 'Content Hero'})
                }
            })
        } else if (props.question?.images?.hero?.url) {
            setHero({src : props.question.images.hero.url, alt: 'Content Hero'})
        }

        let hasVideo = false;

        if(props.question.assets) {
            props.question.assets.forEach(asset => {
                if(asset.pivot.component === 'video' && asset.pivot.sub_component === 'hero') {
                    hasVideo = true;
                    const pauseAt = asset.pivot?.metadata?.pause_at ? parseInt(asset.pivot.metadata.pause_at) : null;
                    const resumeAt = asset.pivot?.metadata?.resume_at ? parseInt(asset.pivot.metadata.resume_at) : null;
                    
                    setVideo({
                        path : asset.path,
                        format : asset.format,
                        pauseAt : pauseAt,
                        resumeAt : resumeAt
                    });
                    
                    // Convert resumeAt to seconds before setting count down
                    setCountDownDuration(resumeAt / 1000);
                }

            });
        }
        
        if(!hasVideo && countDownDuration) {
            setIsCountDownPlaying(true);
        }

    }, [props.question])

    const lockAnswer = () => {
        let buttonState = [];

        for (const iterator of choices) {
            let currentButton = iterator;
            if(!selectedAnswer || currentButton.id !== selectedAnswer.id) {
                currentButton.iconType = process.env.REACT_APP_BUTTON_LOCKED_ICON;
                currentButton.backgroundColor = process.env.REACT_APP_BUTTON_LOCKED_BACKGROUND_COLOR;
                currentButton.opacity = "0.5";
            } 
            buttonState.push(currentButton);
        }

        setChoices(buttonState);
    }

    const handleTimeUp = () => {
        setTimeUp(true); 
        if(video.resumeAt) {
            setShowContdown(false);
            setHeaderMessage(process.env.REACT_APP_SWEEPSTAKES_GUESS_LOCKED_MESSAGE);
            setShowHeader(true);
            lockAnswer();
        } else {
            submitAnswer();    
        }
        
    }
    const updateButtonState = (item = null) => {
        let buttonState = [];

        for (const iterator of choices) {
            let currentButton = iterator;
            if(currentButton.id === item.id) {
                currentButton.iconType = process.env.REACT_APP_BUTTON_SELECTED_ICON;
                currentButton.backgroundColor = process.env.REACT_APP_BUTTON_SELECTED_BACKGROUND_COLOR;
                currentButton.background = process.env.REACT_APP_BUTTON_SELECTED_BACKGROUND;
            } else {
                currentButton.iconType = 'none';
                currentButton.background = process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND;
                currentButton.backgroundColor = process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR;
            }                
            buttonState.push(currentButton);
        }

        setChoices(buttonState);
    } 

    const createMarkup = (richText) => {
        return {__html: richText};
    }

    const submitAnswer = (answer = null) => {
        // Handle no answer
        if(!answer && !selectedAnswer) {
            const buttonFinalState = [];

            for(const iterator of choices) {
                let currentButton = iterator;
                currentButton.backgroundColor = '#AFAFAF';
                buttonFinalState.push(currentButton);
            }

            setHeaderMessage('TIME IS UP!');
            setShowContdown(false);
            setShowHeader(true);
            setChoices(buttonFinalState);                            

            setTimeout(()=>{
                props.callback(false, false);
            }, 5000)            
            
            return;

        } else if (!answer && selectedAnswer) {
            answer = selectedAnswer;
        }else if(!device?.deviceDetails?.uuid) {
            console.log('Abort');
            return;
        } 

        // Submit answer
        const endpoint = user ? `/user/${user.id}/question/${props.question.id}/answer` : `/device/${device.deviceDetails.uuid}/question/${props.question.id}/answer`;
            
        let headers = {}
        headers['x-device-uuid'] = `${device.deviceDetails.uuid}`;

        if(user) {
            headers['Authorization'] = 'Bearer ' + user.token; 
        }
        
        axios.post(
            endpoint, {choice_id : answer.id}, {headers: headers}
        ).then((res)=>{
            let buttonFinalState = [];                
            if (res && res.data) {
                if(answer.id === res.data.correct_choice_id) {
                    // Set correct anwser button classes
                    //setHeaderMessage(process.env.REACT_APP_SWEEPSTAKES_GUESS_CORRECT_MESSAGE);
                    setHeaderImage(correctHeaderImage);
                    for(const iterator of choices) {
                        let currentButton = iterator;
                        currentButton.background = (iterator.id === answer.id) ? process.env.REACT_APP_BUTTON_CORRECT_BACKGROUND : process.env.REACT_APP_BUTTON_LOCKED_BACKGROUND;
                        // currentButton.backgroundColor = (iterator.id === answer.id) ? process.env.REACT_APP_BUTTON_CORRECT_BACKGROUND_COLOR : process.env.REACT_APP_BUTTON_LOCKED_BACKGROUND_COLOR;
                        currentButton.border = (iterator.id === answer.id) ? process.env.REACT_APP_BUTTON_CORRECT_BORDER : '1px solid transparent';
                        currentButton.iconType = (iterator.id === answer.id) ? "check" : 'none';
                        currentButton.opacity = (iterator.id === answer.id) ? "1" : "0.5";
                        buttonFinalState.push(currentButton);
                    }

                    setShowContdown(false);
                    setShowHeader(true);
                    setChoices(buttonFinalState);
                    
                    setTimeout(()=>{
                        props.callback(res.data.response.id, true);
                    }, 5000)

                } else {                    
                    //setHeaderMessage(process.env.REACT_APP_SWEEPSTAKES_GUESS_INCORRECT_MESSAGE);
                    setHeaderImage(incorrectHeaderImage);

                    for(const iterator of choices) {
                        let currentButton = iterator;
                        if(iterator.id === answer.id) {                            
                            currentButton.background = process.env.REACT_APP_BUTTON_INCORRECT_BACKGROUND;
                            // currentButton.backgroundColor = process.env.REACT_APP_BUTTON_INCORRECT_BACKGROUND_COLOR;
                            currentButton.border = (iterator.id === answer.id) ? process.env.REACT_APP_BUTTON_INCORRECT_BORDER : '1px solid transparent';
                            currentButton.iconType = "close"; 
                            currentButton.opacity = "0.5";                           
                        } else if (iterator.id === res.data.correct_choice_id){ 
                            currentButton.background = process.env.REACT_APP_BUTTON_CORRECT_BACKGROUND;
                            // currentButton.backgroundColor = process.env.REACT_APP_BUTTON_CORRECT_BACKGROUND_COLOR;
                            currentButton.iconType = "check";
                            currentButton.opacity = "1";
                        } else {
                            currentButton.background = process.env.REACT_APP_BUTTON_LOCKED_BACKGROUND;
                            // currentButton.backgroundColor = process.env.REACT_APP_BUTTON_LOCKED_BACKGROUND_COLOR;
                            currentButton.opacity = "0.5";
                        }
                        buttonFinalState.push(currentButton);
                    }
                    setShowContdown(false);
                    setShowHeader(true);
                    setChoices(buttonFinalState);
                    setTimeout(()=>{
                        props.callback(null, false);
                    }, 5000)

                }
            } else {

            }
        }).catch((err)=>{

        }).finally();
    }

    const handleButtonClick = (item) => {
        if(process.env.REACT_APP_CONTENT_QUESTION_INMMEDIATE_RESPONSE && process.env.REACT_APP_CONTENT_QUESTION_INMMEDIATE_RESPONSE === 'true' && !video.path) {
            setShowContdown(false);
            setShowHeader(true);
            setTimeUp(true);
            submitAnswer(item);
        } else {
            setSelectedAnswer(item);
            updateButtonState(item);   
        }
    }    

    const countdown = <CountDown
                            marginTop={'10px'}
                            marginBottom={'10px'}
                            duration={countDownDuration} 
                            isPlaying={isCountDownPlaying}
                            onComplete={() => handleTimeUp()} 
                            /> 

    const header = headerImage ? <div style={{
            paddingTop: "20px", 
            paddingBottom : "20px", 
            justifyContent: "center", 
        }}><img src={headerImage} alt='Result Header' style={{width: "100%", maxWidth: "258px"}}/></div>:<div style={{
            fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, 
            fontWeight: "800", 
            fontSize:"32px", 
            color: "white", 
            height: "60px", 
            paddingTop: "20px", 
            paddingBottom : "20px", 
            justifyContent: "center", 
            textTransform: "uppercase"
        }}>{headerMessage}
    </div>

    const startVideo = () => {
        if(videoIsPlaying) {
            console.log('video already playing');
        } else {
            setVideoIsPlaying(true);
            if(video.pauseAt && video.resumeAt) {
                setTimeout(() => {
                    setVideoIsPlaying(false);
                    setIsCountDownPlaying(true);                    
                    setTimeout(() => {
                        setVideoIsPlaying(true);
                    }, video.resumeAt);
                }, video.pauseAt);
            }
        }
    }

    return (
        <div style={{width: "100%", textAlign: "center", fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY}}> 
                {countDownDuration && showCountdown && countdown}
                {showHeader && header}
                {showLogo && <Logo width={"235px"}/>}
            <div style={{
                    color: "black", 
                    backgroundColor: "white", 
                    width: "88%", 
                    marginLeft: "auto", 
                    marginRight: "auto", 
                    height: "auto",
                    display: "block",
                    borderRadius: "8px",
                    paddingBottom: "30px",
                }}>

                {hero && <div style={{paddingBottom: "10px"}}><img alt={hero.alt} src={hero.src} style={{width: "100%", borderTopLeftRadius: "8px", borderTopRightRadius: "8px"}}/></div>}
                {video.path && <Video 
                                    path={video.path} 
                                    format={video.format} 
                                    onPlay={()=>console.log('Video started')}
                                    onPaused={()=>console.log('Video paused')}
                                    onResumed={()=>console.log('Video resumed')}
                                    onEnded={() => {setVideoIsPlaying(false); submitAnswer()}}
                                    muted={true}
                                    showControls={false}
                                    play={videoIsPlaying}
                                    onCanPlayThrough={startVideo}
                                    autoPlay={true}
                                    style={{width: "100%", height: "100%", borderRadius: "10px 10px 0 0", paddingBottom: "10px"}}
                />}
                
                {props.question && (!props.question.display_preferences || props.question.display_preferences?.title ) &&                 
                    <h1 style={{
                        fontSize: "24px", 
                        textTransform: "uppercase", 
                        marginTop: "0px",
                        marginBottom: "0px",
                        padding: "0 20px 0 20px",
                        color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR}}>                    
                            {props.question.display_name}
                    </h1>
                }

                {props.question.description && <div style={{padding : "20px"}} dangerouslySetInnerHTML={createMarkup(props.question.description)}></div>}
                <ul style={{listStyle: "none", padding: "0px", margin: "0px", width:"90%", marginTop: "20px", marginLeft: "auto", marginRight:"auto"}}>{ choices && choices.map((item) =>(
                        <li key={item.id}>
                            <Button 
                            background={item.background}
                            style={{
                                fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                                fontSize: process.env.REACT_APP_BUTTON_FONT_SIZE,
                                fontWeight: "800",
                                marginTop : '15px', 
                                width:"100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textTransform: "uppercase",
                                color: process.env.REACT_APP_BUTTON_COLOR,
                                // backgroundColor: item.backgroundColor,
                                // background : item.REACT_APP_BUTTON_DEFAULT_BACKGROUND,
                                background : item.background ?? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND,
                                boxShadow: process.env.REACT_APP_BUTTON_SHADOW,
                                borderColor: item.borderColor?? "transparent",
                                borderRadius: process.env.REACT_APP_BUTTON_BORDER_RADIUS,                                
                                border: item.border?? process.env.REACT_APP_BUTTON_DEFAULT_BORDER,                                
                                opacity: item.opacity?? "1"
                                }}
                                
                            onClick={!timeUp && isCountDownPlaying ? () => handleButtonClick(item) : null} btnText={(isCountDownPlaying) ? item.text : '?'} iconType={(isCountDownPlaying) ? item.iconType : null}/>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default Question;